<app-progress></app-progress>
<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<div class="mat-typography mt-4">
    <mat-card class="w-full md:w-1/2 mx-auto bg-gray-50 p-4">
    <mat-card-header>
      <mat-card-title>
        <h1>{{userId ? 'Edit User Details' : 'New User'}}</h1>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form (submit)="save()" [formGroup]="userForm">
        <mat-form-field class="form-field-full-width">
          <input class="form-group" formControlName="email" matInput placeholder="Enter email" required
            type="text">
          @if (userForm.get('email').hasError('required')) {
            <mat-error>Email is required</mat-error>
          }
          @if (userForm.get('email').hasError('email')) {
            <mat-error>Invalid email</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field-full-width">
          <input [required]="!!!userId" autocomplete="new-password" class="form-group"
            formControlName="password"
            matInput placeholder="Password" type="password">
          @if (userForm.get('password').hasError('required')) {
            <mat-error>Password is required</mat-error>
          }
          @if (userForm.get('password').hasError('minlength')) {
            <mat-error>Passwords must be at least 6
              characters long
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field-full-width">
          <mat-select (selectionChange)="roleChanged($event)" formControlName="role" placeholder="Role"
            required>
            <mat-option>--</mat-option>
            @for (role of roles; track role) {
              <mat-option [value]="role.value">
                {{role.name}}
              </mat-option>
            }
          </mat-select>
          @if (userForm.get('role').hasError('required')) {
            <mat-error>Please select a role</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field-full-width">
          <mat-select (selectionChange)="accountChanged($event)" formControlName="accountId"
            placeholder="Account"
            required>
            <mat-option>--</mat-option>
            @for (account of accounts; track account) {
              <mat-option [value]="account.id">
                {{account.name}}
              </mat-option>
            }
          </mat-select>
          @if (userForm.get('accountId').hasError('required')) {
            <mat-error>Please select an account
            </mat-error>
          }
        </mat-form-field>
        @if (showFacilities) {
          <mat-form-field class="form-field-full-width">
            <mat-select [multiple]="true" formControlName="facilities" placeholder="Facilities" required>
              @for (facility of facilities | async; track facility) {
                <mat-option [value]="facility.id">
                  {{facility.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <!--mat-selection-list formControlName="facilities">
        TODO: For some reason this doesn't work
        <mat-list-option *ngFor="let facility of facilities | async" [value]="facility.id">
          {{facility.name}}
        </mat-list-option>
      </mat-selection-list-->
      <div class="button-row">
        <button [disabled]="userForm.invalid" color="primary" mat-raised-button type="submit">Save Changes
        </button>
      </div>
    </form>
    @if (globalErrorMessage) {
      <mat-error>
        {{globalErrorMessage}}
      </mat-error>
    }
  </mat-card-content>
</mat-card>
</div>
